export default __webpack_public_path__ + "static/media/DSC03498.982386e1.JPG";